<h3>
    <a ng-click="viewDetails($event, item)">
        {{ item.name }}
    </a>
</h3>
<div style="padding: 5px 0 0 0">
    {{ item.description }}
</div>
